/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file The App component.
 * @author Tom Verschoore de la Houssaije

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sym-app[_ngcontent-%COMP%]{min-height:100%;position:relative;padding-bottom:100px}"];
export { styles as styles };
